import { render, staticRenderFns } from "./Unsubscribers.vue?vue&type=template&id=50a3e18f&"
import script from "./Unsubscribers.vue?vue&type=script&lang=ts&"
export * from "./Unsubscribers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports